import { ProductOfferSortBy } from '@/server/services/vendor/models';

export const DEFAULT_PRODUCT_OFFER_SORT_BY: ProductOfferSortBy = 'price_asc';

export const PRODUCT_OFFER_SORT_OPTIONS: ReadonlyArray<{
    value: ProductOfferSortBy;
    label: string;
}> = [
    { value: 'price_asc', label: 'ارزان‌ترین' },
    { value: 'price_desc', label: 'گران‌ترین' },
    { value: 'rating', label: 'محبوب‌ترین' }
];

export const PRODUCT_SORT_COPY = {
    label: 'مرتب‌سازی:'
} as const;
